import {
  FormCommon,
  FormCommonType,
} from '../strategies/form/strategy.form.common'
import {
  NangoCommon,
  NangoCommonType,
} from '../strategies/nango/strategy.nango.common'
import {
  Oauth2Common,
  Oauth2CommonType,
} from '../strategies/oauth2/oauth2.common'

export type ProviderAuthenticationCommonType =
  | Oauth2CommonType
  | NangoCommonType
  | FormCommonType

export const ProviderAuthenticationCommon = {
  Oauth2: Oauth2Common,
  Nango: NangoCommon,
  Form: FormCommon,
}
